module.exports = __webpack_public_path__ + "img/img-medic-desktop.696e7981.png";